import { Link } from '@tanstack/react-router';
import { Button, Icon } from '@yembo/yemblocks-core';
import { useContext } from 'react';
import { TextMessageContext } from 'src/react/_contexts/TextMessageContext';
import { useJobImageToRoom } from '../_hooks/useJobImageToRoom';
import { useJobImageToRoomMenu } from '../_hooks/useJobImageToRoomMenu';

type Props = {
  url: string;
  isOverlayEnabled: boolean;
  onDownload: (url: string) => void;
  downloadQueue: string[];
};

export const ImageAttachment = ({ url, isOverlayEnabled, onDownload, downloadQueue }: Props): React.JSX.Element => {
  const { rooms, videos, images } = useContext(TextMessageContext);

  const jobImageToRoom = useJobImageToRoom();
  const { roomsMenu, isMovingToRoom, isRoomsMenuOpen } = useJobImageToRoomMenu({
    imageUrl: url,
    jobImageToRoom,
    rooms,
    buttonText: 'Job Image',
  });
  const notSignedUrl = url.split('?X-Amz-Content')[0];

  const getRoomByImage = () => {
    const roomImage = images.find(({ sourceUrl }) => sourceUrl?.includes(notSignedUrl));
    const roomVideo = videos.find(({ key }) => key === roomImage?.videoKey);
    const room = rooms.find(({ key }) => key === roomVideo?.roomKey);

    return room;
  };

  const renderImageOverlay = (image: string): React.JSX.Element => {
    const room = getRoomByImage();

    if (room) {
      return (
        <div className='image-overlay open'>
          <p className='placeholder'>This Image was moved to:</p>
          {/* biome-ignore lint/suspicious/noExplicitAny: router constraint bypass */}
          <Link to={`/job/${room.jobKey}/rooms` as any} search={{ key: room.key } as any}>
            {room.name}
          </Link>
        </div>
      );
    }

    const extension = notSignedUrl.split('.').pop();
    return (
      <div className={`image-overlay ${isMovingToRoom || isRoomsMenuOpen ? 'open' : ''}`}>
        <Button
          kind='flat'
          onClick={() => onDownload(image)}
          isLoading={downloadQueue.includes(image)}
          text={downloadQueue.includes(image) ? 'Downloading' : 'Download'}
          icon={<Icon name='download' />}
        />
        {['jpeg', 'jpg'].includes(extension ?? '') && roomsMenu}
      </div>
    );
  };

  return (
    <div className='media-item' key={url}>
      <img alt='images' className='image-message' src={url} />
      {isOverlayEnabled && renderImageOverlay(url)}
    </div>
  );
};
